(() => {
  if (window.glassifyDesktopFiltersInitialized) return;
  window.glassifyDesktopFiltersInitialized = true;
  const selector = '.desktop-filter-dropdown';

  function updateDrawerViewport() {
    const drawer = document.querySelector('#site-filters-sidebar');
    if (!drawer) return;
    const viewport = window.visualViewport;
    // Browser bars and the keyboard can reduce the visible area independently
    // of CSS viewport units. Do not resize the layout during pinch zoom.
    const height = viewport?.scale === 1 ? viewport.height : window.innerHeight;
    if (height > 0) drawer.style.setProperty('--filter-viewport-height', `${height}px`);
  }

  function closeDropdowns(except) {
    document.querySelectorAll(`${selector}[open]`).forEach(dropdown => {
      if (dropdown !== except) dropdown.open = false;
    });
  }

  function filterValues(dropdown) {
    const search = dropdown.querySelector('[data-js-filter-search]');
    if (!search) return;
    search.value = dropdown.dataset.searchQuery || '';
    const query = search.value.trim().toLocaleLowerCase('da');
    let visible = 0;
    dropdown.querySelectorAll('[data-filter-value]').forEach(item => {
      item.hidden = !item.dataset.filterValue.toLocaleLowerCase('da').includes(query);
      if (!item.hidden) visible++;
    });
    const empty = dropdown.querySelector('.desktop-filter-empty');
    if (empty) empty.hidden = visible !== 0;
  }

  function positionDropdown(dropdown) {
    const panel = dropdown.querySelector('.desktop-filter-panel');
    if (!panel) return;
    panel.style.left = '0px';
    const rect = panel.getBoundingClientRect();
    const offset = Math.max(0, rect.right - window.innerWidth + 16);
    panel.style.left = `${-offset}px`;
    panel.style.maxHeight = `${Math.max(160, Math.min(480, window.innerHeight - rect.top - 16))}px`;
  }

  document.addEventListener('toggle', event => {
    const dropdown = event.target;
    if (!dropdown.matches(selector) || !dropdown.open) return;
    closeDropdowns(dropdown);
    filterValues(dropdown);
    positionDropdown(dropdown);
  }, true);

  document.addEventListener('pointerdown', event => {
    const dropdown = event.target.closest(selector);
    if (!dropdown) closeDropdowns();
    else if (event.target.closest('summary')) closeDropdowns(dropdown);
  });

  // Native toggle events are queued. Close the previous category before the
  // summary's default action so fast clicks cannot reopen the previous panel.
  document.addEventListener('click', event => {
    const dropdown = event.target.closest(selector);
    if (dropdown && event.target.closest('summary')) closeDropdowns(dropdown);
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const dropdown = document.querySelector(`${selector}[open]`);
    if (!dropdown) return;
    event.preventDefault();
    dropdown.open = false;
    dropdown.querySelector('summary').focus();
  });

  document.addEventListener('input', event => {
    if (!event.target.matches('[data-js-filter-search]')) return;
    const dropdown = event.target.closest(selector);
    if (!dropdown) return;
    dropdown.dataset.searchQuery = event.target.value;
    filterValues(dropdown);
  });

  document.addEventListener('collection:filters-updated', () => {
    document.querySelectorAll(selector).forEach(dropdown => {
      filterValues(dropdown);
      if (dropdown.open) positionDropdown(dropdown);
    });
  });

  window.addEventListener('resize', () => {
    closeDropdowns();
    updateDrawerViewport();
  });
  window.visualViewport?.addEventListener('resize', updateDrawerViewport);
  document.addEventListener('sidebar:open', updateDrawerViewport, true);
  updateDrawerViewport();
})();
